import AnalyticsController from '../analytics_controller'

export default class extends AnalyticsController {
  static targets = [
    'corporationId',
    'chart',
    'chartLoading',
    'retryContent',
    'daterange',
    'exportLink',
    'type'
  ]

  get analyticParams() {
    return {
      ...super.analyticParams,
      'type': this.paymentType
    }
  }

  get paymentType() {
    if (this.targets.has('type')) {
      return this.typeTarget.value
    }
    return 'amount'
  }
}
